import { AccountCircle } from "@mui/icons-material";
import { Alert, Box, Button, iconButtonClasses, Menu as BaseMenu, styled } from "@mui/material";

import { DEFAULT_TOPBAR_HEIGHT, USERMANAGEMENT_BANNER_HEIGHT } from "fond/widgets/PageContent/constants";

export const MainContainer = styled(Box)`
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const Container = styled(Box)`
  height: ${DEFAULT_TOPBAR_HEIGHT}px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.palette.biarri.primary.midnight};
  color: white;
  padding: ${({ theme }) => theme.spacing(1)};
  padding-left: 0;
  font-size: ${({ theme }) => theme.typography.h5.fontSize};

  .${iconButtonClasses.root}, .icon-navlink {
    margin: ${({ theme }) => theme.spacing(0, 0.5)};
    color: ${({ theme }) => theme.palette.common.white};

    &:hover {
      background-color: ${({ theme }) => theme.palette.background.topbar.hover};
    }
  }
`;

export const Menu = styled(BaseMenu)(
  ({ theme }) => `
    & .MuiMenu-list {
      width: 198px;
      padding: ${theme.spacing(0.5)}px 0;
    }
  `
);

export const AccountIcon = styled(AccountCircle)(({ theme }) => ({
  fill: theme.palette.biarri.primary.lightGrey,
}));

export const Banner = styled(Alert)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  zIndex: 10,
  paddingRight: theme.spacing(2),
  height: USERMANAGEMENT_BANNER_HEIGHT,
}));

export const ManageAccountButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1),
  whiteSpace: "nowrap",
}));

export const SettingsButton = styled(Button)`
  color: ${({ theme }) => theme.palette.biarri.primary.lightGrey};

  .settings-button-text {
    text-align: left;
    margin: ${({ theme }) => theme.spacing(0, 1)};
  }

  .settings-button-account-avatar {
    width: ${({ theme }) => theme.spacing(4)};
    height: ${({ theme }) => theme.spacing(4)};
    margin-left: ${({ theme }) => theme.spacing(2)};
  }

  .settings-button-user-avatar {
    width: ${({ theme }) => theme.spacing(2.5)};
    height: ${({ theme }) => theme.spacing(2.5)};
    font-size: 10px;
    position: relative;
    align-self: end;
    margin-left: ${({ theme }) => theme.spacing(-1.25)};
    padding: 1px 0 0 1px;
  }
`;
